/* eslint-disable no-console */

export const logError = (message: string, ...optionalParams: any[]) => log(message, "error", ...optionalParams);
export const logWarning = (message: string, ...optionalParams: any[]) => log(message, "warning", ...optionalParams);
export const logInfo = (message: string, ...optionalParams: any[]) => log(message, "info", ...optionalParams);
export const logDebug = (message: string, ...optionalParams: any[]) => log(message, "debug", ...optionalParams);
export function log(message: string, severity: LogSeverity = "info", ...optionalParams: any[]) {
	if (severity === "warning") {
		console.warn(message, ...optionalParams);
	} else if (severity === "error") {
		console.error(message, ...optionalParams);
	} else {
		console.log(message, ...optionalParams);
	}
}
type LogSeverity = "info" | "warning" | "error" | "debug";
